import { render, staticRenderFns } from "./BlackPins.vue?vue&type=template&id=0858f58c&"
import script from "./BlackPins.vue?vue&type=script&lang=js&"
export * from "./BlackPins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports